<template>
  <div class="container">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div
      class="
        row
        mt-2 mt-lg-5
        pt-2
        justify-content-center
        align-items-center
        text-center
      "
    >
      <div class="col-12 col-lg-2">
        <div class="payment-logo">
          <a href="/">
            <img src="@/assets/amej-pay.png" alt="Amejpay" />
          </a>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <h2
          class="text-bold"
          v-if="merchant_payment_details.merchant_account_detail"
        >
          {{ merchant_payment_details.merchant_account_detail.company_name }}
        </h2>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-lg-7 pb-0">
        <b-card>
          <div class="row mb-2 justify-content-center">
            <div class="col-12 col-lg-6 ">
              <h4 class="text-center m-0">
                Hello
                <span v-if="profile && profile.author">{{
                  profile.author.full_name
                }}</span
                ><span v-else>User</span> !
              </h4>
            </div>
            <!-- <div class="col-3">
              <h2>I am not sushil !</h2>
              <router-link :to="{ name: 'merchant-payment' }">
                <b-button class="w-100 mt-2" variant="primary">
                  Change User
                </b-button>
              </router-link>
            </div> -->
          </div>
          <h4 class="text-center mb-2">Welcome Back</h4>
          <h4 class="text-center pb-3">Your Payment Information</h4>
          <div class="row mt-2 justify-content-center">
            <div class="col-7 col-lg-5">
              <h5>Amount:</h5>
              <h5>Tax/Vat:</h5>
            </div>
            <div class="col-4 col-lg-3">
              <h4>
                ${{
                  merchant_payment_details.merchant_payment_detail.cart_amount.toFixed(
                    2
                  )
                }}
              </h4>
              <h4>
                ${{
                  merchant_payment_details.merchant_payment_detail.tax_amount.toFixed(
                    2
                  )
                }}
              </h4>
            </div>
          </div>
          <div class="row mb-2 justify-content-center">
            <div class="col-7 col-lg-5">
              <h5>Total Amount:</h5>
            </div>
            <div class="col-4 col-lg-3">
              <h4>
                ${{
                  (
                    parseFloat(
                      merchant_payment_details.merchant_payment_detail
                        .cart_amount
                    ) +
                    parseFloat(
                      merchant_payment_details.merchant_payment_detail
                        .tax_amount
                    )
                  ).toFixed(2)
                }}
              </h4>
            </div>
          </div>
          <div class="row mt-0">
            <div class="col-12 col-lg-6">
              <b-button
                class="w-100"
                variant="amej-button"
                v-b-modal.modal-confirm
              >
                Pay Now
              </b-button>
            </div>
            <div class="col-12 col-lg-6">
              <b-button
                class="w-100"
                variant="amej-button"
                @click="cancelPayment"
              >
                Cancel Payment
              </b-button>
            </div>
          </div>
          <div class="row justify-content-center pt-3">
            <div class="col-2">
              <div class="payment-logo">
                <a href="/">
                  <img src="@/assets/amej-pay.png" alt="Amejpay" />
                </a>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <b-modal
      id="modal-confirm"
      title="Confirm Payment"
      centered
      header-bg-variant="dark"
      header-text-variant="light"
      footer-bg-variant="secondary"
      footer-text-variant="light"
      ok-disabled="true"
      hide-footer
    >
      <template>
        <div class="row">
          <div class="col-12">
            <h4>Please Enter your pin for confirmation</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <input
              type="text"
              v-model="pinNumber"
              min="4"
              max="6"
              required
              class="w-100"
              pattern="[0-9]+"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            />
            <label alt="Pin Number" placeholder="Pin Number"></label>
          </div>
          <span
            v-if="pinError"
            style="color: rgb(207 16 16); padding-left: 20px; font-size: 15px;"
            >Invalid Pin Number.</span
          >
        </div>
      </template>
      <template>
        <b-button size="sm" variant="primary" @click="submitConfirmPayment()"
          >Confirm</b-button
        >
        <b-button size="sm" variant="default">&nbsp;</b-button>
        <b-button size="sm" variant="danger" @click="cancelModel()"
          >Cancel</b-button
        >
      </template>
    </b-modal>

    <b-toast
      id="error-toast"
      variant="danger"
      solid
      append-toast
      toaster="b-toaster-top-center"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Error!!!</strong>
      </div>
      <div
        class="text-danger"
        v-for="(error, index) in errors.auth"
        :key="index"
      >
        {{ error }}
      </div>
    </b-toast>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Footer from "../../reuseable_components/Footer";

const axios = require("axios");

export default {
  components: {
    Footer,
    Loading,
  },
  name: "PaymentConfirm",
  data() {
    return {
      isLoading: false,
      transactionid: this.$route.params.transactionid,
      pinNumber: "",
      pinError: false,
      pinErrorMessage: "",
      pinSuccess: false,
      text: "Login Form",
      show: false,
      successUrlValue: "",
      failUrlValue: "",
      reloaded: false,
      errors: { auth: [] },
    };
  },
  created() {
    this.getMerchantPaymentDetailByTransactionId(this.transactionid);
    this.listProfileForMerchant();
  },
  computed: {
    ...mapState([
      "successmessage",
      "errormessage",
      "message",
      "merchant_payment_details",
      "profile",
    ]),
  },
  mounted() {
    // reload the page if profile is not set
    if (window.localStorage.getItem("reloaded")) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      window.localStorage.removeItem("reloaded");
    } else {
      // Set a flag so that we know not to reload the page twice.
      window.localStorage.setItem("reloaded", "1");
      location.reload();
    }

    if (this.transactionid == "") {
      // Guard: merchant_payment_details may not be loaded yet (initializes as [])
      let detail =
        this.merchant_payment_details &&
        this.merchant_payment_details.merchant_payment_detail;
      if (detail && detail.failure_url) {
        let reloadUrl = detail.failure_url + "?status=fail&transaction_key=";
        window.open(reloadUrl, "_self");
      }
    }
  },
  methods: {
    ...mapActions([
      "getMerchantPaymentDetailByTransactionId",
      "listProfileForMerchant",
    ]),
    ...mapMutations(["setToken"]),
    submitConfirmPayment() {
      this.pinError = false;
      if (this.pinNumber == "") {
        this.pinError = true;
        this.pinErrorMessage = "PIN number required.";
      } else if (/[^0-9]+/.test(this.pinNumber)) {
        this.pinError = true;
        this.pinErrorMessage = "Invalid PIN number.";
      } else if (this.pinNumber.length < 4 || this.pinNumber.length > 6) {
        this.pinError = true;
        this.pinErrorMessage = "PIN number between 4 - 6 digits.";
      } else {
        this.errors.auth = [];
        // Start Merchant Wallet Payment
        this.successUrlValue =
          this.merchant_payment_details.merchant_payment_detail.success_url +
          "?status=success&transaction_key=" +
          this.merchant_payment_details.merchant_payment_detail
            .transaction_key +
          "&transaction_id=" +
          this.transactionid;
        this.failUrlValue =
          this.merchant_payment_details.merchant_payment_detail.failure_url +
          "?status=fail&transaction_key=" +
          this.merchant_payment_details.merchant_payment_detail
            .transaction_key +
          "&transaction_id=" +
          this.transactionid;

        let merchantWalletPaymentRequest = new FormData();
        merchantWalletPaymentRequest.append(
          "amount",
          this.merchant_payment_details.merchant_payment_detail.cart_amount
        );
        merchantWalletPaymentRequest.append(
          "to",
          this.merchant_payment_details.merchant_account_detail.business_email
        );
        merchantWalletPaymentRequest.append(
          "remarks",
          "Merchant Payment from Transaction id " + this.transactionid
        );

        axios.defaults.headers.common["authorization"] =
          "Bearer " + this.$store.state.token;
        axios
          .post("merchantwalletpayment", merchantWalletPaymentRequest)
          .then((response) => {
            if (response.status == 200) {
              // Finalize the Merchant Wallet Payment with using PIN Verification
              let merchantWalletPaymentConfirmationRequest = new FormData();
              merchantWalletPaymentConfirmationRequest.append(
                "transaction_id",
                this.transactionid
              );
              merchantWalletPaymentConfirmationRequest.append(
                "transfer_id",
                response.data.transaction
              );
              merchantWalletPaymentConfirmationRequest.append(
                "transaction_PIN",
                this.pinNumber
              );

              axios.defaults.headers.common["authorization"] =
                "Bearer " + this.$store.state.token;
              axios
                .put(
                  "merchantwalletpayment/confirm",
                  merchantWalletPaymentConfirmationRequest
                )
                .then((responsenew) => {
                  if (responsenew.status == 200) {
                    // do the process for return response to user
                    window.localStorage.setItem("token", "");
                    this.setToken("");
                    window.open(this.successUrlValue, "_self");
                  } else {
                    // window.open(this.failUrlValue, "_self");
                    this.errors.auth = ["Invalid Transaction PIN."];
                    this.$bvToast.show("error-toast");
                  }
                })
                .catch((error) => {
                  if (error) {
                    // return to failure page
                    // window.open(this.failUrlValue, "_self");
                    this.errors.auth = ["Wrong Transaction PIN."];
                    this.$bvToast.show("error-toast");
                  }
                });
              ///
            }
          })
          .catch((error) => {
            if (error) {
              // return to failure page
              // window.location.href = this.failUrlValue;
              this.errors.auth = ["Transaction Error! Try Again."];
              this.$bvToast.show("error-toast");
            }
          });
        ///
      }
    },
    cancelPayment() {
      window.localStorage.setItem("token", "");
      this.setToken("");

      let reloadUrl =
        this.merchant_payment_details.merchant_payment_detail.failure_url +
        "?status=failtransaction_key=" +
        this.transactionid;
      window.open(reloadUrl, "_self");
    },
    cancelModel() {
      this.$bvModal.hide("modal-confirm");
    },
  },
};
</script>
